import "./sellscreendialogs.scss";
import * as React from "react";
import { type LocalDatabaseSale } from "../../../Data/_Bases/BaseSalesRepository";
import HeldSale from "../HeldSales/HeldSale";

interface Props {
    results: Array<LocalDatabaseSale>;
}

export default class MultipleInvoices extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <div className="multiple-results">
                <p>Multiple invoices have been found, please select the correct invoice from the list below:</p>
                <div className="invoices">
                    {this.props.results.map((result, index) => (
                        <HeldSale
                            key={index}
                            sale={result}
                            canRetrieve
                        />
                    ))}
                </div>
            </div>
        );
    }
}
